import React, { Fragment, PureComponent } from "react";
import { Header, Grid, Button, Divider, Menu, Checkbox, Input, Dropdown, Icon, Label } from "semantic-ui-react";
import isEmpty from "lodash/isEmpty";
import set from "lodash/set";

class ProductFeatures extends PureComponent {
  state = { currentFeature: null };

  toggleFeature = () => {
    const { featureOptions, features } = this.props;
    const defaultSlug = featureOptions[0].value;
    const defaultFeature = features.find(feature => feature.slug === defaultSlug);
    const value = this.initialValueForFeature(defaultFeature);

    this.setState({
      currentFeature: {
        featureSlug: defaultSlug,
        visible: false,
        value
      }
    });
  };

  preventSubmit = e => {
    if (e.key === "Enter") e.preventDefault();
  };

  resetFeature = () => {
    this.setState({ currentFeature: null });
  };

  handleFeatureSelection = (e, data) => {
    const { features } = this.props;
    const selectedFeature = features.find(feature => feature.slug === data.value);
    const initalValue = this.initialValueForFeature(selectedFeature);

    this.setState((prevState, props) => ({
      currentFeature: {
        ...prevState.currentFeature,
        featureSlug: data.value,
        value: initalValue
      }
    }));
  };

  handleFeatureChange = (e, data) => {
    const { name, value } = data;

    if (name === "visible") {
      this.setState((prevState, props) => ({
        currentFeature: {
          ...prevState.currentFeature,
          visible: !prevState.currentFeature.visible
        }
      }));
      return;
    }

    if (name === "value" && value === "true") {
      this.setState((prevState, props) => ({
        currentFeature: {
          ...prevState.currentFeature,
          value: prevState.currentFeature.value === "true" ? "false" : "true"
        }
      }));
      return;
    }

    this.setState((prevState, props) => ({
      currentFeature: { ...prevState.currentFeature, [name]: value }
    }));
  };

  validateSize = (e, data) => {
    const { value } = data;
    if (value < 0) {
      this.setState({ error: "Size must be a positive number" });
    } else {
      this.handlePeriodChange(e, data);
      this.setState({ error: null });
    }
  };

  handleBlur = e => {
    if (e.currentTarget.value === "") {
      this.setState({ error: "Size is required" });
    } else {
      this.setState({ error: null });
    }
  };

  initialValueForFeature = feature => {
    switch (feature.valueType) {
      case "boolean":
        return "false";
      case "period":
        return [0, "months"];
      default:
        return "";
    }
  };

  handlePeriodChange = (e, data) => {
    this.setState((prevState, props) => {
      const { currentFeature } = prevState;
      set(currentFeature, data.name, data.value);
      return {
        currentFeature: {
          ...currentFeature
        }
      };
    });
  };

  featureValueFormControl = () => {
    const { features } = this.props;
    const { currentFeature, error } = this.state;

    const selectedFeature = features.find(feature => feature.slug === currentFeature.featureSlug);

    if (!selectedFeature) return <span />;
    switch (selectedFeature.valueType) {
      case "boolean":
        return (
          <Checkbox
            name="value"
            value={"true"}
            checked={currentFeature.value === "true"}
            onChange={this.handleFeatureChange}
            data-test="featureValue"
          />
        );
      case "period":
        return (
          <Grid textAlign="center">
            <Grid.Row columns={2}>
              <Grid.Column widescreen={7} largeScreen={7} tablet={16} mobile={16}>
                <Input
                  fluid
                  type="number"
                  name="value[0]"
                  value={currentFeature.value[0]}
                  onChange={this.validateSize}
                  onBlur={this.handleBlur}
                  size="large"
                  onKeyPress={this.preventSubmit}
                />
                {error && (
                  <Label basic color="red" pointing>
                    {error}
                  </Label>
                )}
              </Grid.Column>
              <Grid.Column widescreen={9} largeScreen={9} tablet={16} mobile={16}>
                <Dropdown
                  fluid
                  placeholder="Period"
                  selection
                  options={[
                    { text: "Month(s)", value: "months" },
                    { text: "Year(s)", value: "years" }
                  ]}
                  name="value[1]"
                  value={currentFeature.value[1]}
                  onChange={this.handlePeriodChange}
                  style={{ display: "inline-block" }}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        );
      default:
        return (
          <Input
            maxLength="30"
            name="value"
            placeholder="Value for feature"
            value={currentFeature.value}
            onChange={this.handleFeatureChange}
            onKeyPress={this.preventSubmit}
          />
        );
    }
  };

  handleAddProductFeature = () => {
    this.setState({ currentFeature: null });
    this.props.onItemAdd({ ...this.state.currentFeature });
  };

  isExistsInTemplatesFeatures = (productFeature, templatesFeatures) => {
    const productFeatureInTemplate = templatesFeatures.filter(
      templatesFeature => templatesFeature.featureSlug === productFeature.featureSlug
    );

    return !isEmpty(productFeatureInTemplate);
  };

  existingFeature = (item, productMetadataItems) => {
    if (isEmpty(productMetadataItems)) return false;
    if (this[item.featureSlug] !== undefined) return this[item.featureSlug];

    const existingProductMetadataItem = productMetadataItems.filter(
      productMetadataItem => productMetadataItem.featureSlug === item.featureSlug
    );
    if (isEmpty(existingProductMetadataItem)) return [];

    this[existingProductMetadataItem[0].featureSlug] = {
      slug: existingProductMetadataItem[0].featureSlug,
      value: existingProductMetadataItem[0].value,
      visible: existingProductMetadataItem[0].visible
    };
    return this[existingProductMetadataItem[0].featureSlug];
  };

  render() {
    const {
      productMetadataItems,
      featureOptions,
      features,
      productTemplateAssigned,
      isTemplateSelected,
      templatesFeatures
    } = this.props;
    const { currentFeature, error } = this.state;
    const templateApplied = productTemplateAssigned || isTemplateSelected;

    return (
      <Fragment>
        <Header>Features</Header>
        <Grid textAlign="left">
          <Grid.Row columns={5}>
            <Grid.Column widescreen={4} largeScreen={4} tablet={4} mobile={4}>
              Name
            </Grid.Column>
            <Grid.Column widescreen={5} largeScreen={5} tablet={5} mobile={5} textAlign="center">
              Values
            </Grid.Column>
            <Grid.Column widescreen={2} largeScreen={2} tablet={2} mobile={2} textAlign="center">
              Visible
            </Grid.Column>
            <Grid.Column widescreen={5} largeScreen={5} tablet={2} mobile={2} />
          </Grid.Row>

          <Divider />

          {!isTemplateSelected &&
            productMetadataItems &&
            productMetadataItems.map((item, idx) => {
              const feature = features.find(feature => feature.id === item.featureSlug);
              const disableDestroyButton = !(!isEmpty(item.links?.destroy) || isEmpty(item.id) || !productTemplateAssigned);

              return (
                !item.removed && (
                  <Grid.Row columns={4} key={idx} data-test="featureRow">
                    <Grid.Column widescreen={4} largeScreen={4} tablet={4} mobile={4} className="break-word">
                      {feature.name + ` (${item.featureSlug})`}
                    </Grid.Column>
                    <Grid.Column widescreen={5} largeScreen={5} tablet={5} mobile={5} textAlign="center">
                      {feature.valueType === "boolean" ? (
                        <Checkbox disabled checked={item.value === "true"} />
                      ) : (
                        <span>{item.value}</span>
                      )}
                    </Grid.Column>
                    <Grid.Column widescreen={2} largeScreen={2} tablet={2} mobile={2} textAlign="center">
                      <Checkbox
                        name="visible"
                        checked={item.visible}
                        onChange={(e, data) => this.props.onItemUpdate("feature", item.id, data)}
                        disabled={disableDestroyButton}
                      />
                    </Grid.Column>
                    <Grid.Column widescreen={5} largeScreen={5} tablet={2} mobile={2} textAlign="right">
                      <Icon
                        name="trash alternate"
                        link
                        color={isTemplateSelected ? "yellow" : "orange"}
                        onClick={this.props.onItemRemove(idx)}
                        disabled={disableDestroyButton}
                        data-test="deleteFeature"
                      />
                    </Grid.Column>
                  </Grid.Row>
                )
              );
            })}

          {isTemplateSelected &&
            productMetadataItems &&
            productMetadataItems.map((item, idx) => {
              const feature = features.find(feature => feature.id === item.featureSlug);

              if (!this.isExistsInTemplatesFeatures(item, templatesFeatures) && item.removed === true)
                return (
                  <Grid.Row columns={4} className="diff-red" key={idx}>
                    <Grid.Column widescreen={4} largeScreen={4} tablet={4} mobile={4} className="break-word">
                      {feature.name + ` (${item.featureSlug})`}
                    </Grid.Column>
                    <Grid.Column widescreen={5} largeScreen={5} tablet={5} mobile={5} textAlign="center">
                      {feature.valueType === "boolean" ? (
                        <Checkbox disabled checked={item.value === "true"} />
                      ) : (
                        <span>{item.value}</span>
                      )}
                    </Grid.Column>
                    <Grid.Column widescreen={2} largeScreen={2} tablet={2} mobile={2} textAlign="center">
                      <Checkbox
                        disabled={true}
                        name="visible"
                        checked={item.visible}
                        onChange={(e, data) => this.props.onItemUpdate("feature", item.id, data)}
                      />
                    </Grid.Column>
                    <Grid.Column widescreen={5} largeScreen={5} tablet={2} mobile={2} textAlign="right">
                      <Icon name="add alternate" link color="yellow" onClick={this.props.onItemAddedAgain(idx)} />
                      <Icon name="trash alternate" link color="yellow" onClick={this.props.onItemRemove(idx)} />
                    </Grid.Column>
                  </Grid.Row>
                );
              if (!this.isExistsInTemplatesFeatures(item, templatesFeatures))
                return (
                  <Grid.Row columns={4} key={idx}>
                    <Grid.Column widescreen={4} largeScreen={4} tablet={4} mobile={4} className="break-word">
                      {feature.name + ` (${item.featureSlug})`}
                    </Grid.Column>
                    <Grid.Column widescreen={5} largeScreen={5} tablet={5} mobile={5} textAlign="center">
                      {feature.valueType === "boolean" ? (
                        <Checkbox disabled checked={item.value === "true"} />
                      ) : (
                        <span>{item.value}</span>
                      )}
                    </Grid.Column>
                    <Grid.Column widescreen={2} largeScreen={2} tablet={2} mobile={2} textAlign="center">
                      <Checkbox
                        disabled={true}
                        name="visible"
                        checked={item.visible}
                        onChange={(e, data) => this.props.onItemUpdate("feature", item.id, data)}
                      />
                    </Grid.Column>
                    <Grid.Column widescreen={5} largeScreen={5} tablet={2} mobile={2} textAlign="right">
                      <Icon name="trash alternate" link color="yellow" onClick={this.props.onItemRemove(idx)} />
                    </Grid.Column>
                  </Grid.Row>
                );
            })}

          {isTemplateSelected &&
            templatesFeatures &&
            templatesFeatures.map((item, idx) => {
              const feature = features.find(feature => feature.id === item.featureSlug);

              return (
                <Grid.Row columns={4} className="diff-green" key={idx}>
                  <Grid.Column widescreen={4} largeScreen={4} tablet={4} mobile={4} className="break-word">
                    {feature.name + ` (${item.featureSlug})`}
                  </Grid.Column>
                  <Grid.Column widescreen={5} largeScreen={5} tablet={5} mobile={5} textAlign="center">
                    {feature.valueType === "boolean" ? (
                      <Checkbox disabled checked={item.value === "true"} />
                    ) : (
                      <span>{item.value}</span>
                    )}
                    {!isEmpty(this.existingFeature(item, productMetadataItems)) &&
                      this[item.featureSlug].value !== item.value && (
                        <Grid>
                          <Grid.Row columns={1}>
                            <Grid.Column textAlign="center">
                              <Label basic color="red" pointing>
                                Was{" "}
                                {feature.valueType === "boolean" ? (
                                  <Checkbox
                                    disabled={true}
                                    name="oldValue"
                                    data-test="oldValue"
                                    checked={this[item.featureSlug].value === "true"}
                                  />
                                ) : (
                                  <span>{this[item.featureSlug].value}</span>
                                )}
                              </Label>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      )}
                  </Grid.Column>
                  <Grid.Column widescreen={2} largeScreen={2} tablet={2} mobile={2} textAlign="center">
                    <Checkbox
                      disabled={true}
                      name="visible"
                      checked={item.visible}
                      onChange={(e, data) => this.props.onItemUpdate("feature", item.id, data)}
                    />
                    {!isEmpty(this.existingFeature(item, productMetadataItems)) &&
                      this[item.featureSlug].visible !== item.visible && (
                        <Grid>
                          <Grid.Row columns={1}>
                            <Grid.Column textAlign="center">
                              <Label basic color="red" pointing>
                                Was{" "}
                                <Checkbox
                                  disabled={true}
                                  name="oldVisible"
                                  data-test="oldVisible"
                                  checked={this[item.featureSlug].visible}
                                />
                              </Label>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      )}
                  </Grid.Column>
                  <Grid.Column widescreen={5} largeScreen={5} tablet={2} mobile={2} textAlign="right">
                    <Icon
                      name="trash alternate"
                      link
                      color="orange"
                      onClick={this.props.onItemRemove(idx)}
                      disabled={true}
                    />
                  </Grid.Column>
                </Grid.Row>
              );
            })}
        </Grid>

        {currentFeature ? (
          <Grid textAlign="left">
            <Grid.Column widescreen={4} largeScreen={4} tablet={4} mobile={4}>
              <Dropdown
                fluid
                name="featureSlug"
                data-test="productFeaturesOptions"
                placeholder="Feature"
                selection
                options={featureOptions}
                value={currentFeature.featureSlug}
                onChange={this.handleFeatureSelection}
              />
            </Grid.Column>
            <Grid.Column widescreen={5} largeScreen={5} tablet={5} mobile={5} textAlign="center">
              {this.featureValueFormControl()}
            </Grid.Column>
            <Grid.Column widescreen={2} largeScreen={2} tablet={2} mobile={2} textAlign="center">
              <Checkbox
                name="visible"
                value={1}
                checked={currentFeature.visible}
                onChange={this.handleFeatureChange}
                data-test="featureVisible"
              />
            </Grid.Column>
            <Grid.Column widescreen={5} largeScreen={5} tablet={2} mobile={2} textAlign="right">
              <Button
                size="mini"
                color="orange"
                content="Add"
                onClick={this.handleAddProductFeature}
                disabled={error !== null && error !== undefined}
                data-test="addFeature"
              />
              <Button
                size="mini"
                style={{
                  backgroundColor: "#fff",
                  color: "orange"
                }}
                content="Cancel"
                onClick={this.resetFeature}
                data-test="cancelFeature"
              />
            </Grid.Column>
            <Grid.Row />
          </Grid>
        ) : (
          <Menu size="small" borderless secondary>
            <Menu.Item
              disabled={isEmpty(featureOptions)}
              header
              link
              icon="add"
              content="Add New Feature"
              className="text orange"
              onClick={this.toggleFeature}
              data-test="plusFeatureOption"
            />
          </Menu>
        )}
      </Fragment>
    );
  }
}

export default ProductFeatures;
